import { FieldArray } from 'formik';
import { GripVertical } from 'lucide-react';
import { RankingRuleProps } from 'modules/championship/ui/components/form-parts/rules/types';

import React, { ReactNode } from 'react';
import * as DnD from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import { theme } from 'styles/theme/theme';
import UDText from 'ud-ui/components/text';
import { onDragEnd } from 'ud-ui/helpers/drag-n-drop';

interface ExtendedRankingRuleProps extends RankingRuleProps {
  children?: ReactNode;
}

const RankingBase: React.FC<ExtendedRankingRuleProps> = ({ sportType = 'general', children }) => {
  const { t } = useTranslation();

  return (
    <>
      <UDText type="callout" className="mb-3">
        ♟ Ранжирование команд в случае равенства очков
      </UDText>
      <FieldArray name="settings.ranking">
        {(fieldProps) => (
          <DnD.DragDropContext onDragEnd={(r) => onDragEnd(r, fieldProps.move)}>
            {/* TODO: The "Connect(Droppable): Support for defaultProps will be removed from memo components" warning comes from react-beautiful-dnd internals, not from our code.
                To remove it in the future, consider migrating to @hello-pangea/dnd, a maintained fork without this warning. */}
            <DnD.Droppable droppableId="ranking-rules" direction="vertical" type="ranking-rule">
              {(dnd) => (
                <div ref={dnd.innerRef} {...dnd.droppableProps}>
                  {fieldProps.form.values.settings.ranking.map((rule: any, index: number) => (
                    <DnD.Draggable
                      key={`ranking-rule-${rule?.value ?? index}`}
                      draggableId={`ranking-rule-${rule?.value ?? index}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="flex flex-row items-center py-1"
                        >
                          <GripVertical size={20} color={theme.colors.SurfaceRomanSilver30} />
                          <UDText type="subhead" className="text-surfaceRaisinBlack50">
                            {t(`championship.settings.${rule.name}`)}
                          </UDText>
                        </div>
                      )}
                    </DnD.Draggable>
                  ))}
                  {dnd.placeholder}
                </div>
              )}
            </DnD.Droppable>
          </DnD.DragDropContext>
        )}
      </FieldArray>

      {/* Место для дополнительных полей */}
      {children}
    </>
  );
};

export default RankingBase;
